module.exports = __webpack_public_path__ + "img/编组 （5).f030fe23.png";